import Player from '@vimeo/player';

//------------------
// Components 
//------------------

var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
var removeList = [];

const contentBlock = document.querySelector('.content');
var cursor = document.querySelector('.context-cursor');

var cursorText = '';
var cursorTypeing = false;

var prevUrl = false;

var mouse = {
    x: false,
    y: false
};

if(!isTouch){
    document.addEventListener('mousemove', function(e){
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        custom_cursor(e);
    });
}

var transitioning = false;

var activeMain = false;
var vimeoPlayers = [];
var activeSlide = false;
var globZ = 2;
var landingShow = document.querySelector('.landing-slideshow');

var key_down = [];

document.addEventListener('keydown', function(e){
  
    if(!key_down.includes(e.key)){
        key_down.push(e.key);
        if(key_down.length === 3 && key_down.includes('d') && key_down.includes('a') &&  key_down.includes('n')){
            cheat();
        }
    }
});

document.addEventListener('keyup', function(e){
    const index = key_down.indexOf(e.key);
    if (index > -1) {
        key_down.splice(index, 1); 
    }
});


window.touchDevice = false;

if ('ontouchstart' in window || navigator.maxTouchPoints) {
    window.touchDevice = true;
}

function page_load(){

    index_sheet();
    bind_ajax_links();

    for (let a = 0; a < vimeoPlayers.length; a++) {
        vimeoPlayers[a][0].pause();
    }

    vimeoPlayers = [];


    const landing = document.querySelector('.landing');

    if(landing){
        setTimeout(function(){

            var way = pallete[Math.floor(Math.random()*pallete.length)];
            if(way){
                landing.style.color = way[0];
                landing.style.background = way[1];
            }
            
            document.querySelector('meta[name="theme-color"]').setAttribute('content', way[1]);
            changeFaviconColor(way[1]);

            document.body.style.backgroundColor = way[1];
            document.body.style.color = way[0];

            landing.style.opacity = 1;
            landing.classList.add('animate');

            setTimeout(function(){
                slideshow();
                setTimeout(function(){
                    landing.parentNode.removeChild(landing);
                }, 1000);
            }, 1500);

        }, 500);
    }else{


        let bak =  document.querySelector('.clip').style.backgroundColor;
        if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
            bak = '#F5F5F5';
        }

        let front = document.querySelector('.clip').style.color;
        document.body.style.color = front;
        document.body.style.backgroundColor = bak;

        document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
        changeFaviconColor(bak);
        

        slideshow();
    }

    landingShow = document.querySelector('.landing-slideshow');


    var gif = document.querySelectorAll('.gif');

    for (let index = 0; index < gif.length; index++) {
       
        const element = gif[index];
        
        if(element.dataset.src){
            element.src = element.dataset.src;
        }

        element.classList.remove('gif');
        
    }
    
};

window.onload = function(event) {

    activeMain = document.querySelector('main');
    
    page_load();

    if(document.querySelector('.studio')){
        document.querySelector('.studio').classList.add('active');
    }
    
};

function cheat(){

    var clips = document.querySelectorAll('.clip');

    for (let a = 0; a < clips.length-1; a++) {
        const element = clips[a];
        element.classList.add('cheating');
        element.style.clipPath = generateRandomClipPath();
    }

    setTimeout(function(){
        for (let a = 0; a < clips.length-1; a++) {
            const element = clips[a];
            element.classList.add('cheating');
            element.style.clipPath = generateRandomClipPath();
        }
    }, 10);

    var cheat_timer = setInterval(function(){

        for (let a = 0; a < clips.length-1; a++) {
            const element = clips[a];
            element.classList.add('cheating');
            element.style.clipPath = generateRandomClipPath();
            
        }
        
    }, 1000);

    setTimeout(function(){
        clearInterval(cheat_timer);
        for (let a = 0; a < clips.length-1; a++) {
            const element = clips[a];
            element.classList.remove('cheating');
            element.style.clipPath = '';
        }
    }, 10000);


};

function index_sheet(){

    const indexTrigs = document.querySelectorAll('.index-trig');
    const indexSheet = document.querySelector('.index-sheet');
    

    for (let a = 0; a < indexTrigs.length; a++) {
        const trig = indexTrigs[a];

        if(!trig.classList.contains('bound')){

            trig.classList.add('bound');
            trig.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                globZ++;
                indexSheet.style.zIndex = globZ;

                indexSheet.classList.toggle("active");
                console.log(prevUrl);
                if (window.location.href.indexOf("all-projects") > -1) {
                    window.history.pushState({}, '', '/');
                    prevUrl = '/';
                }else{
                    window.history.pushState({}, '', '/all-projects');
                    prevUrl = '/all-projects';
                    
                }

                if(indexSheet.classList.contains('active')){
                    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#fff');
                    changeFaviconColor('#ccc');
                }else{

                    var act = document.querySelector('.slide.active');
                    if(!act){
                        act =  document.querySelector('.clip');
                    }else{
                        act = act.querySelector('.clip');
                    }

                    let bak = act.style.backgroundColor;
                    if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
                        bak = '#F5F5F5';
                    }
                    
                    let front = act.style.color;
                    document.body.style.color = front;
                    document.body.style.backgroundColor = bak;
                    
                    setTimeout(function(){
                        document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
                        changeFaviconColor(bak);
                    }, 760);
                }
               
            });
        }
        
    }

};

function bind_ajax_links(){

    var links = document.querySelectorAll('a');
    for (let a = 0; a < links.length; a++) {
       let elm = links[a];

        if(isInternalLink(elm) && !elm.classList.contains('bound')){
            elm.classList.add('bound');
            elm.addEventListener('click', load_content);
        }
        
    }

};

function load_content(e){

    e.preventDefault();
    e.stopPropagation();

    if(!transitioning){
    
        let elm = this;
    
        let newUrl = elm.href;
        let path = getUrlPathFromHref(newUrl);
    
        if(window.location.pathname === '/studio' && path === '/studio'){

            const indexSheet = document.querySelector('.index-sheet');

            if(indexSheet.classList.contains('active')){
                indexSheet.classList.remove('active');
            }else{
                path = '/';
                load_page(path);
            }
            
        }else{
            load_page(path);
        }

    }
   

  
    
}



function load_page(path){

    transitioning = true;

    var cur = document.querySelector('main');

    var curUrl = window.location.pathname;

    const indexSheet = document.querySelector('.index-sheet');
    
    cur.style.pointerEvents = 'none';

    window.history.pushState({}, '', path);
    prevUrl = path;

    fetch(path+'?type="ajax"')
    .then(function(response) {
        return response.text();
    })
    .then(function(data) {

        

        let html =  extractInnerContent(data);
        var content = html.querySelector('main');

        globZ++;
        content.style.zIndex = globZ;
    
        contentBlock.append(content);

        if(content.querySelector('.studio')){

            setTimeout(function(){
                let bak =  content.querySelector('.clip').style.backgroundColor;
                if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
                    bak = '#F5F5F5';
                }

                let front = content.querySelector('.clip').style.color;
                document.body.style.color = '#000';

                document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
                changeFaviconColor(bak);
                content.querySelector('.studio').classList.add('active');
            },10);
        }

        var closeIndex = false;

        if(indexSheet.classList.contains('active')){
            closeIndex = true;
        }

        removeList.push(cur);

        var fistClip = content.querySelector('.clip');

        fistClip.addEventListener("animationend", clean_up);
        fistClip.addEventListener("transitionend", clean_up);
 
        function clean_up(){

            setTimeout(function(){
            while (removeList.length > 0) {
                let elm = removeList[removeList.length-1];
                contentBlock.removeChild(elm);
                removeList.pop(); 
            }
            
            if(closeIndex){
                indexSheet.classList.remove('active');
            }

            transitioning = false;
            }, 300);
        };

    
        activeMain = content;
        page_load();

    
        setTimeout(function(){
            let bak = content.querySelector('.clip').style.backgroundColor;
            if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
                bak = '#F5F5F5';
            }
            setTimeout(function(){
                document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
                changeFaviconColor(bak);
            }, 760);
            content.style.opacity = 1;
        }, 10);

     

        if(document.querySelector('.close-link')){
            document.querySelector('.close-link').href = curUrl;
        }
        
    })
    .catch(function(error) {
        console.error('Error:', error);
    });
   
        

};


window.addEventListener('popstate', function(event) {
    location.reload(true);
});


//   ───────────────────────────────────────────▶                        
//   Funks                           
//   ───────────────────────────────────────────▶                        
     
function slideshow(){
    const slideshows = activeMain.querySelectorAll('.slideshow');
    if(slideshows){
        for (let a = 0; a < slideshows.length; a++) {
            const slideshow = slideshows[a];
            bind_slidehow(slideshow);    
        }
        
    }
};

function bind_slidehow(slideshow){

   
    const slides = slideshow.querySelectorAll('.slide');
    var slideIndex = 0;
    var slideLength = slides.length;
    var zPos = 1;

    var slide = slides[slideIndex];
    
    slide.classList.add('active');
    slide.classList.add('next');

    let vid = slide.querySelector('.player');
    let video = slide.querySelector('video');

    if(vid){
        bind_player(vid);
    }

    if(video){
        bind_video(video);
    }

    let front = slides[slideIndex].querySelector('.clip').style.color;
    document.body.style.color = front;

    

    setTimeout(function(){
       
        let bak = slides[slideIndex].querySelector('.clip').style.backgroundColor;
       
        if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
            bak = '#F5F5F5';
        }

        document.body.style.backgroundColor = bak;
      

        document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
        changeFaviconColor(bak);
    }, 760);

    // binding all the info trigs as there is many.
    const infoTrigs = slideshow.querySelectorAll('.info-trig');
    const infoSlide = slideshow.querySelector('.info-slide');

    for (let a = 0; a < infoTrigs.length; a++) {
        const trig = infoTrigs[a];

        if(infoSlide){
            trig.addEventListener('click', animateToInfo);
        }else{
            trig.style.display = 'none';
        }
        
    }


    if(infoSlide){
        let links = infoSlide.querySelectorAll('a');
        for (let a = 0; a < links.length; a++) {
            const element = links[a];
            element.addEventListener('click', function(e){
                e.stopPropagation();
            });
            
        }
    }
    for (let a = 0; a < slides.length; a++) {
        const el = slides[a];

        el.addEventListener("animationstart", function() {

            if(el === activeSlide){

                let bak = activeSlide.querySelector('.clip').style.backgroundColor;

                if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
                    bak = '#F5F5F5';
                }

                let front = activeSlide.querySelector('.clip').style.color;
                document.body.style.color = front;
                document.body.style.backgroundColor = bak;
                

                document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
                changeFaviconColor(bak);

            }

        }, false);

        el.addEventListener("animationend", function() {
          
            el.classList.remove('prev');
            el.classList.remove('next');
            
            if(el === activeSlide){

                for (let b = 0; b < slides.length; b++) {
                    const element = slides[b];
                    if(element !== activeSlide){
                        element.classList.remove('active');
                    }
                    
                }

                let bak = activeSlide.querySelector('.clip').style.backgroundColor;
                if(bak === '#ffffff'||bak === 'rgb(255, 255, 255)'){
                    bak = '#F5F5F5';
                }

                let front = activeSlide.querySelector('.clip').style.color;

                document.body.style.color = front;
                document.body.style.backgroundColor = bak;
                

                document.querySelector('meta[name="theme-color"]').setAttribute('content', bak);
                changeFaviconColor(bak);
            }
        }, false);

    }

    document.removeEventListener("keydown",key_check);
    document.addEventListener("keydown" ,key_check);

    function key_check(e){

        var slide = '';

        if (e.key === 'ArrowLeft'){

            slideIndex--;             
            if(slideIndex < 0){
                slideIndex = slides.length-1;
            }
            
            slide = slides[slideIndex];
            slide.classList.add('prev');

        } else if (e.key === 'ArrowRight'){

            slideIndex++;

            if(slideIndex >= slides.length){
                slideIndex = 0;
            }

            slide = slides[slideIndex];
            slide.classList.add('next');
        }


        for (let a = 0; a < vimeoPlayers.length; a++) {
            vimeoPlayers[a][0].pause();
        }

        zPos++;    

        if(slide){

            let vid = slide.querySelector('.player');
            let video = slide.querySelector('video');
            

            if(vid){
                bind_player(vid);
            }

            if(video){
                bind_video(video);
            }

            slide.style.zIndex = zPos;
            animateSlide(slide);
        }

       

    };
    
    detectSwipe(slideshow, function(direction) {

        var slide = '';


        if(direction === 'left'){
            slideIndex++;
            if(slideIndex >= slides.length){
                slideIndex = 0;
            }

            slide = slides[slideIndex];
            slide.classList.add('next');
        }else if(direction === 'right'){
            slideIndex--;             
            if(slideIndex < 0){
                slideIndex = slides.length-1;
            }
            
            slide = slides[slideIndex];
            slide.classList.add('prev');

        }

        for (let a = 0; a < vimeoPlayers.length; a++) {
            vimeoPlayers[a][0].pause();
        }

        zPos++;

        if(slide){

            let vid = slide.querySelector('.player');
            let video = slide.querySelector('video');

            if(vid){
                bind_player(vid);
            }
            
            if(video){
                bind_video(video);
            }

           
            slide.style.zIndex = zPos;
            animateSlide(slide);

        }

   

    });


    slideshow.addEventListener('click', function(e){

        var slide = '';
        let x = e.clientX;

        var margins = 0;
        if(document.querySelector('.loading-slide')){
            margins = 20;
            if(window.innerWidth<600){
                margins = 36;
            }
        }
        
        let ne = x > (window.innerWidth/100) * (50 + margins);
        let pe = x < (window.innerWidth/100) * (50 - margins);
        
        if(pe){
            
            e.preventDefault();

            slideIndex--;             
            if(slideIndex < 0){
                slideIndex = slides.length-1;
            }
            
            slide = slides[slideIndex];
            slide.classList.add('prev');

        }
        
        if(ne){

            e.preventDefault();

            slideIndex++;
            if(slideIndex >= slides.length){
                slideIndex = 0;
            }

            slide = slides[slideIndex];
            slide.classList.add('next');
        }

        if(isTouch && !pe && !ne){
            slide = slides[slideIndex];
            const aTag = slide.querySelector('a.content-sizer');
            aTag.click();
            console.log(aTag);
        }

        if(pe || ne){

            for (let a = 0; a < vimeoPlayers.length; a++) {
                vimeoPlayers[a][0].pause();
            }

            zPos++;

            if(slide){
                let vid = slide.querySelector('.player');
                let video = slide.querySelector('video');

                if(vid){
                    bind_player(vid);
                }
                
                if(video){
                    bind_video(video);
                }
              
                slide.style.zIndex = zPos;
                animateSlide(slide);
            }

           
        }
    });


    function animateSlide(slide){


        activeSlide = slide;
    
        if(slide.classList.contains('active')){
            slide.classList.remove('active');
        }
        setTimeout(function(){
            slide.classList.add('active');
        }, 10);

        if(landingShow){
            let per = 100/(slides.length-1);
            let leftPer = per * slideIndex;
            const homeLinks = landingShow.querySelectorAll('.home-link');
         
            for (let a = 0; a < homeLinks.length; a++) {
                const homeLink = homeLinks[a];
                const ab = homeLink.querySelector('a');
                if(ab){
                    ab.style.left = leftPer +'%';
                    ab.style.transform = 'translateX(-' + leftPer +'%)';
                }
                
            }

        }
    }

    function animateToInfo(e){

        e.preventDefault();
        e.stopPropagation();

        for (let i = slideIndex+1; i < slideLength; i++) {
            zPos++;
            slides[i].style.zIndex = zPos;
        }

        var slidaCoutn = slideIndex;
        var timeC = 0;

        do {

            slidaCoutn++;
            
            if(slidaCoutn < slideIndex+1 && slidaCoutn !== slideLength){
                if(slides[slidaCoutn]){
                    trigAni(slides[slidaCoutn], timeC);
                }
                timeC++;
            }

            if(slidaCoutn === slideLength){
                trigAni(slides[slideLength-1], timeC);   
            }

        } while (slidaCoutn <= slideLength);
    
    
        slideIndex = slideLength - 1;
    
        function trigAni(slide, a){

            slide.classList.add('next');
            setTimeout(function(){
                animateSlide(slide);
            }, a * 150);

        }

    }
    
}


function bind_video(video){
    video.play();
    video.addEventListener('play', function(){
        let parent = video.parentNode;
        let cover = parent.querySelector('img');
        if(cover){
            cover.style.display = 'none';
        }
    });
}

   
function bind_player(vid){

    if(vid.classList.contains('bound')){
        for (let a = 0; a < vimeoPlayers.length; a++) {
            const vim = vimeoPlayers[a]; 

            if( vim[1] === vid.dataset.id){
                vim[0].play();
            }
            
        }
    }else{

        const options = {
            id: vid.dataset.id,
            resoponsive: true,
            loop: true,
            controls: false,
            autopause: true,
            muted: 1,
            cache: true,
            dnt: true,
        };

        const coverImage = vid.parentNode.querySelector('img');
        const player = new Player(vid, options);
        vimeoPlayers.push([player, vid.dataset.id]);

        player.on('play', vidPlayed);
        player.play();

        vid.classList.add('bound');

    }


    function vidPlayed(e){
        let parent = vid.parentNode;
        let cover = parent.querySelector('img');
        if(cover){
            cover.style.display = 'none';
        }
    }
}

function custom_cursor(e){


    
    cursor.style.left = mouse.x + 'px';
    cursor.style.top = mouse.y + 'px';


    var margins = 0;
    var nText = 'Next';
    if(document.querySelector('.loading-slide')){
        margins = 20;
        nText = 'View';
    }

    let ne = mouse.x > (window.innerWidth/100) * (50 + margins);
    let pe = mouse.x < (window.innerWidth/100) * (50 - margins);
    
    if(ne){
        nText = 'Next';
    }

    if(pe){
        nText = 'Prev';
    }

    if(!ne && !pe){
        document.body.classList.add('slide-link-active');
    }else{
        document.body.classList.remove('slide-link-active');
    }

    if(document.querySelector('.studio') || e.target.tagName === 'A' || e.target.classList.contains('index-trig') || e.target.classList.contains('info-trig') || document.querySelector('.landing') || document.querySelector('.index-sheet.active')){
        cursor.style.display = 'none';
    }else{

       
        cursor.style.display = 'block';
        

        if(!cursorTypeing && cursorText !== nText){
            cursorTypeing = true;
            typeIt(cursorText, nText);
        }
    }


};


function typeIt(from, to){

    var cur = from;
    var mins = to.length;
    const time = 50;
    cursorText = to;


    function typeDown(){
        cur = cur.substring(0, cur.length - 1);
        
        setTimeout(function(){
            cursor.innerHTML = cur;

            if(cur.length === 0){
                if(from.length){
                    cursor.classList.remove(from);
                }
                typeUp();
            }else{
                typeDown();
            }

        }, time);
    };

    function typeUp(){  

        mins--;
        cur = to;
        cur = cur.substring(0, cur.length - mins);
        cursor.classList.add(to);
        setTimeout(function(){
            
            cursor.innerHTML = cur;

            if(mins > 0){
                typeUp();
            }else{
                cursorTypeing = false;
            }
            
        }, time);
    };


    typeDown();

};

                                                                                                                                          
                                                                     
//   ───────────────────────────────────────────▶                        
//   ( )_( )( ___)(  )  (  _ \( ___)(  _ \/ __)                           
//    ) _ (  )__)  )(__  )___/ )__)  )   /\__ \                           
//   (_) (_)(____)(____)(__)  (____)(_)\_)(___/                           
//    ───────────────────────────────────────────▶                        
                                                                           
                                                        
function isInternalLink(link) {

    var currentHostname = window.location.hostname;
    var linkHostname = getHostnameFromHref(link.href);

    // Compare the hostnames
    if(link.href.includes('action')){
        return false;
    }else{
        return currentHostname === linkHostname;
    }
}

function getHostnameFromHref(href) {

    if(href){
        var url = new URL(href);
        return url.hostname;
    }else{
        return false;
    }
}

function getUrlPathFromHref(href) {
    var link = document.createElement('a');
    link.href = href;

    return link.pathname;
}

function extractInnerContent(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement;
}


// Function to detect swipe direction on mobile devices
function detectSwipe(element, callback) {

    var touchstartX = 0;
    var touchstartY = 0;
    var touchendX = 0;
    var touchendY = 0;


    element.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }, false);


    element.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleSwipe();
    }, false);


    function handleSwipe() {
        var deltaX = touchendX - touchstartX;
        var deltaY = touchendY - touchstartY;
        var threshold = 50; // Minimum distance to be considered a swipe

        // Determine direction
        if (Math.abs(deltaX) > Math.abs(deltaY)) { // Horizontal swipe
            if (Math.abs(deltaX) > threshold) {
                if (deltaX > 0) {
                    callback('right');
                } else {
                    callback('left');
                }
            }
        } else { // Vertical swipe
            if (Math.abs(deltaY) > threshold) {
                if (deltaY > 0) {
                    callback('down');
                } else {
                    callback('up');
                }
            }
        }
    }
}


function generateRandomClipPath() {
    let clipPathPoints = [];
    for (let i = 0; i < 6; i++) {
        let x = Math.random() * 100;
        let y = Math.random() * 100;
        clipPathPoints.push(`${x}% ${y}%`);
    }
    return `polygon(${clipPathPoints.join(', ')})`;
}



function changeFaviconColor(color) {
    document.querySelector('link[rel="icon"]').setAttribute('href', 'data:image/svg+xml,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" fill="${color}"><circle cx="75" cy="75" r="50"/></svg>`));
}


document.addEventListener('DOMContentLoaded', () => {
    // Function to remove background
    function removeBackground(image) {
      image.classList.add('loaded');
    }
  
    // Select all existing images and attach the load event listener
    const images = document.querySelectorAll('img');
    images.forEach(image => {
      if (image.complete) {
        // If image is already loaded, apply the background removal immediately
        removeBackground(image);
      } else {
        // Otherwise, set up the event listener
        image.addEventListener('load', () => removeBackground(image));
      }
    });
  
    // Set up a MutationObserver to listen for new images being added to the DOM
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.tagName === 'IMG') {
              if (node.complete) {
                removeBackground(node);
              } else {
                node.addEventListener('load', () => removeBackground(node));
              }
            } else if (node.querySelectorAll) {
              // If the added node is a container, look for any images within it
              const newImages = node.querySelectorAll('img');
              newImages.forEach(image => {
                if (image.complete) {
                  removeBackground(image);
                } else {
                  image.addEventListener('load', () => removeBackground(image));
                }
              });
            }
          });
        }
      });
    });
  
    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
  });